import * as React from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { Template } from "../types/template";
import { getTemplateVersion, getVersions } from "../utils";
import { useAppSelector } from "../../../store/hooks";
import { MarketplaceIcon } from "../components/MarketplaceIcon";
import { Tag } from "antd";

interface Props {
  template: Template;
  unfiltered?: boolean;
}
export const MarketplaceTemplateCard: React.FC<Props> = ({ template, unfiltered }) => {
  const theme = useAppSelector((state) => state.theme.theme);

  const versions = getVersions(template);
  const templateVersion = getTemplateVersion(template, versions[versions.length - 1]);

  return (
    <>
      <Link
        to={`${template.name}`}
        className={clsx("template-card rounded-md cursor-pointer border")}
        style={{
          minHeight: 180,
          backgroundColor: theme === "dark" ? "var(--color-gray-1400)" : "var(--color-gray-50)",
          opacity: unfiltered ? 0.5 : undefined,
        }}
      >
        <div
          className="h-1/3 flex pt-4 pb-2 px-4 justify-between items-start gap-4 rounded-t-md keep-light"
          style={{ backgroundColor: "white" }}
        >
          {template.hasIcon !== false && (
            <div
              className="h-full flex items-center justify-center"
              style={{
                width: "auto",
                maxWidth: 75,
                height: 30,
              }}
            >
              <MarketplaceIcon templateName={template.name} hasIcon={template.hasIcon} className="object-contain w-full h-full" />
            </div>
          )}
          <Tag>{`v${templateVersion?.appVersion}`}</Tag>
        </div>
        <div className="h-2/3 flex pb-4 px-4 flex-col pt-2">
          <div className="text-lg font-semibold template-card-name">{template.name}</div>
          <div className="text-sm">{templateVersion?.description}</div>
        </div>
      </Link>
    </>
  );
};
